import { render, staticRenderFns } from "./Permit.vue?vue&type=template&id=5bac5051&lang=pug&"
import script from "./Permit.vue?vue&type=script&lang=js&"
export * from "./Permit.vue?vue&type=script&lang=js&"
import style0 from "./Permit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports